// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FieldLabel_wrapper__7-eAe","label":"FieldLabel_label__1Txnl","validationIcon":"FieldLabel_validationIcon__1q2N0"};